module.exports = __webpack_public_path__ + "static/media/add manager.4d84af15.svg";